export const ShareList = [
    {
        img: 'https://static-1253442168.file.myqcloud.com/xupload/20210913_1.png',
        name: '耀月'
    },
    {
        img: 'https://static-1253442168.file.myqcloud.com/xupload/20210913_2.png',
        name: '芳华'
    },
    {
        img: 'https://static-1253442168.file.myqcloud.com/xupload/20210913_3.png',
        name: '春野'
    },
    {
        img: 'https://static-1253442168.file.myqcloud.com/xupload/20210913_4.png',
        name: '信马'
    },
    {
        img: 'https://static-1253442168.file.myqcloud.com/xupload/20210913_5.png',
        name: '云纤'
    },
    {
        img: 'https://static-1253442168.file.myqcloud.com/xupload/20210913_6.png',
        name: '子风'
    },
    {
        img: 'https://static-1253442168.file.myqcloud.com/xupload/20210913_7.png',
        name: '远方'
    },
    {
        img: 'https://static-1253442168.file.myqcloud.com/xupload/20210913_8.png',
        name: '易遥'
    },
    {
        img: 'https://static-1253442168.file.myqcloud.com/xupload/20210913_9.png',
        name: '寻见'
    },
    {
        img: 'https://static-1253442168.file.myqcloud.com/xupload/20210913_10.png',
        name: '岁月'
    }
]


// WEBPACK FOOTER //
// ./src/components/shareCardSlide/ShareList.js